import { render, staticRenderFns } from "./NewGoal.vue?vue&type=template&id=99e66bf4"
import script from "./NewGoal.vue?vue&type=script&lang=js"
export * from "./NewGoal.vue?vue&type=script&lang=js"
import style0 from "./NewGoal.vue?vue&type=style&index=0&id=99e66bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports